module.exports = "uniform sampler2D tDiffuse;\nin vec2 vUv;\nvoid main() {\n    vec4 texel = texture( tDiffuse, vUv );\n    outFragColor = texel;\n}\n";